export type ResearchTab = 'backtests' | 'portfolios' | 'optimizations' | 'prices' | 'artifacts' | 'users' | 'keys' | 'mcp' | 'audit';

export type ResearchFilters = {
  symbol: string;
  strategy: string;
  tag: string;
  artifact_type: string;
  sec_type: string;
  data_source: string;
  data_type: string;
  timeframe: string;
  indexes: string;
};

export type ResearchPriceSeries = {
  symbol: string;
  sec_type: string;
  data_source: string;
  data_type?: string;
  timeframe: string;
  multiplier: number;
  storage?: string;
};

const routeTabs: ResearchTab[] = ['backtests', 'portfolios', 'optimizations', 'prices', 'artifacts', 'users', 'keys', 'mcp', 'audit'];

export const researchRouteBase = (pathname: string) => /^\/research(?:\/|$)/.test(pathname) ? '/research' : '';

export function buildResearchRouteUrl(
  pathname: string,
  tab: ResearchTab,
  page: number,
  limit: number,
  filters: ResearchFilters,
  selectedSeries: ResearchPriceSeries | null,
): string {
  const params = new URLSearchParams();
  if (page > 1) params.set('page', String(page));
  if (limit !== 20) params.set('limit', String(limit));
  if (filters.symbol && filters.symbol.length < 500) params.set('symbol', filters.symbol);
  if (filters.strategy && ['backtests', 'optimizations'].includes(tab)) params.set('strategy', filters.strategy);
  if (filters.tag && tab === 'artifacts') params.set('tag', filters.tag);
  if (filters.artifact_type && tab === 'artifacts') params.set('artifact_type', filters.artifact_type);

  if (tab === 'prices') {
    if (filters.sec_type) params.set('sec_type', filters.sec_type);
    if (filters.data_source) params.set('data_source', filters.data_source);
    if (filters.data_type) params.set('data_type', filters.data_type);
    if (filters.timeframe) params.set('timeframe', filters.timeframe);
    if (filters.indexes) params.set('indexes', filters.indexes);

    if (selectedSeries) {
      params.set('s_symbol', selectedSeries.symbol);
      params.set('s_sec_type', selectedSeries.sec_type);
      params.set('s_data_source', selectedSeries.data_source);
      if (selectedSeries.data_type) params.set('s_data_type', selectedSeries.data_type);
      params.set('s_timeframe', selectedSeries.timeframe);
      params.set('s_multiplier', String(selectedSeries.multiplier));
      if (selectedSeries.storage) params.set('s_storage', selectedSeries.storage);
    }
  }

  const query = params.toString();
  return `${researchRouteBase(pathname)}/${tab}${query ? `?${query}` : ''}`;
}

export function parseResearchRoute(pathname: string, search: string, hash: string) {
  const basePath = researchRouteBase(pathname);
  const legacyRoute = hash.match(/^#\/([^?]+)(\?.*)?$/);
  const appPath = basePath ? pathname.slice(basePath.length) : pathname;
  const route = legacyRoute?.[1] || appPath.split('/').filter(Boolean)[0] || '';
  const tab = routeTabs.includes(route as ResearchTab) ? route as ResearchTab : 'backtests';
  const params = legacyRoute
    ? new URLSearchParams(legacyRoute[2] || '')
    : new URLSearchParams(search);
  const needsReplace = Boolean(legacyRoute) || route !== tab || appPath !== `/${tab}`;
  const query = params.toString();

  return {
    tab,
    params,
    needsReplace,
    url: `${basePath}/${tab}${query ? `?${query}` : ''}`,
  };
}
